import { SearchCategories } from '../components/search/search.enum';
import { Coords, SearchResponse } from '../swagger-api';
import { GeoBoundingBoxBody, MapSearchPassedData, MapState } from './map.interface';
import { PaginationState } from './pagination.interface';

export interface SearchParameters {
  queryText: string;
  itemKind: SearchCategories;
}

export interface SearchParams {
  searchTerm: string;
  pagination: PaginationState;
}

export interface SearchState {
  data?: MapSearchPassedData;
  params?: SearchParameters;
  pagination?: PaginationState;
  sortParams?: SortParams;
  excludeIds?: string[];
}

export interface SearchRequest extends SearchState {
  stringifiedRequest?: string;
}

export interface SearchRequestObject {
  aggregate_attributes?: SearchAggregateAttributes[];
  search_attributes: SearchAttributes[];
  sort_attributes?: SortAttributes[];
  limit?: number;
  offset?: number;
}

export interface SearchResultResponse extends SearchResponse {
  params?: SearchParameters | MapSearchPassedData;
  pagination?: PaginationState;
}

export interface SearchAttributes {
  name: string;
  operator?: string;
  values?: string[];
  body?: GeoBoundingBoxBody;
  location?: Coords;
}

export interface SearchAggregateAttributes {
  name: string;
  value: object;
  nested_aggregate_attributes?: SearchAggregateAttributes[];
}

export interface SortAttributes {
  name: string;
  ascending: boolean;
  newestDate?: boolean;
}

export interface FormSearchParams {
  previousState: SearchState;
  currentState: SearchState;
  applyLocation?: boolean;
  locationLiteral?: string;
}

export enum SortingOrderType {
  NAME = 'name',
  DATE = 'date',
  SCORE = 'score',
}

export interface SortParams {
  ascending: boolean;
  orderType: SortingOrderType;
}

export interface RequestSearchParams {
  state: SearchState;
  applyLocationAttrs: boolean;
  locationLiteral?: string;
}

export interface RequestAttributeParams {
  state: MapState;
  applyLocationAttrs: boolean;
  aggregated?: boolean;
  locationLiteral?: string;
}

export interface LocationDetailsParams {
  state: MapState;
  applyLocationAttrs: boolean;
  aggregated?: boolean;
  locationLiteral?: string;
}
